import React, { useState, useEffect } from 'react';
import { FaTelegram, FaXTwitter } from "react-icons/fa6";
import './App.css'; // Import the CSS file
import LoadingScreen from './LoadingScreen'; // Import the LoadingScreen component

function App() {
  const [showMiniHeader, setShowMiniHeader] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const revealSections = () => {
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          section.classList.add("revealed");
        }
      });
    };
    window.addEventListener("scroll", revealSections);
    revealSections();
    return () => window.removeEventListener("scroll", revealSections);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > document.querySelector('header').offsetHeight) {
        setShowMiniHeader(true);
      } else {
        setShowMiniHeader(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="container">
      {/* Loading Screen */}
      <LoadingScreen /> {/* Add the LoadingScreen component */}

      {/* Main Header */}
      <div className="main-header">
        The Ultimate Fusion of Speed & Elegance Token
      </div>
      <header className="header">
        <img src="https://zupimages.net/up/25/05/kdn8.png" alt="BUGATTEA Logo" className="logo" />
        <nav className="nav">
          <ul className="nav-list">
            <li><a href="" className="nav-link">Home</a></li>
            <li><a href="#contract-section" className="nav-link" onClick={(e) => { e.preventDefault(); document.getElementById('contract-section')?.scrollIntoView({ behavior: 'smooth' }); }}>Contract Address</a></li>
            <li className="social-icons">
              <a href="https://t.me/bugattea" className="social-icon" target="_blank"><FaTelegram /></a>
              <a href="https://x.com/BugatTeaToken" className="social-icon" target="_blank"><FaXTwitter /></a>
            </li>
          </ul>
        </nav>
      </header>

      {/* Mini Header on Scroll */}
      {showMiniHeader && (
        <div className="mini-header">
          <img src="https://zupimages.net/up/25/05/kdn8.png" alt="BUGATTEA Logo" className="mini-logo" />
          <nav className="mini-nav">
            <ul className="mini-nav-list">
              <li><a href="#top" className="mini-nav-link">Home</a></li>
              <li><a href="#contract-section" className="mini-nav-link" onClick={(e) => { e.preventDefault(); document.getElementById('contract-section')?.scrollIntoView({ behavior: 'smooth' }); }}>Contract Address</a></li>
              <li className="mini-social-icons">
                <a href="https://t.me/bugattea" className="mini-social-icon" target="_blank"><FaTelegram /></a>
                <a href="https://x.com/BugatTeaToken" className="mini-social-icon" target="_blank"><FaXTwitter /></a>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {/* Hero Section */}
      <section className="hero-section">
        <img src="https://zupimages.net/up/25/05/kdn8.png" alt="BUGATTEA Logo" className="hero-logo" />
        <h1 className="hero-title">$BUGATTEA</h1>
        <p className="hero-subtitle">Where speed meets luxury in the memecoin revolution.</p>
        <button className="hero-button pulse">Buy Now</button>
        <p className="hero-description">
          BugatTea isn't just another memecoin—it's a statement. A revolution. A passion project built from the ground up
          with love and an unwavering belief in the power of speed and elegance. Inspired by the fusion of luxury
          supercars and the timelessness of a fine tea break, BugatTea was born to dominate the crypto highway.
        </p>
        <p className="hero-quote">
          "One late night, sipping on a warm cup of tea, staring at the roaring beast of a car I dreamed of owning,
          it hit me—why not merge these two worlds? Something fast, yet timeless. Elegant, yet exhilarating. Thus, BugatTea was born.<br/><br/>And now, I invite you to join this journey." 🚀<br/><br/>
        </p>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <h3 className="roadmap-title">BugatTea in Action</h3>
        <div className="gallery-grid">
          <div className="gallery-item">
            <img src="https://zupimages.net/up/25/05/gnbv.png" alt="BUGATTEA Visual 1" className="gallery-image" />
          </div>
          <div className="gallery-item">
            <img src="https://zupimages.net/up/25/05/pq2s.png" alt="BUGATTEA Visual 2" className="gallery-image" />
          </div>
          <div className="gallery-item">
            <img src="https://zupimages.net/up/25/05/aq06.png" alt="BUGATTEA Visual 3" className="gallery-image" />
          </div>
          <div className="gallery-item">
            <img src="https://zupimages.net/up/25/05/kd5l.png" alt="BUGATTEA Visual 4" className="gallery-image" />
          </div>
          <div className="gallery-item">
            <img src="https://zupimages.net/up/25/05/94xj.png" alt="BUGATTEA Visual 5" className="gallery-image" />
          </div>
          <div className="gallery-item">
            <img src="https://zupimages.net/up/25/05/phyk.png" alt="BUGATTEA Visual 6" className="gallery-image" />
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section id="roadmap" className="roadmap-section">
        <h3 className="roadmap-title">Roadmap</h3>
        <div className="roadmap-container">
          <div className="roadmap-line"></div>
          <div className="roadmap-phase">
            <div className="phase-text">
              <h4 className="phase-title">Phase 1</h4>
              <p className="phase-description">Token Launch & Community Growth</p>
            </div>
            <div className="phase-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
          </div>
          <div className="roadmap-phase reverse">
            <div className="phase-text">
              <h4 className="phase-title">Phase 2</h4>
              <p className="phase-description">NFT Collection & Marketplace</p>
            </div>
            <div className="phase-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
          </div>
          <div className="roadmap-phase">
            <div className="phase-text">
              <h4 className="phase-title">Phase 3</h4>
              <p className="phase-description">Partnerships with Luxury Brands</p>
            </div>
            <div className="phase-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section id="contract-section" className="community-section">
        <div className="community-container">
          <h3 className="community-title">Join the BugatTea Community!</h3>
          <p className="hero-description">
            Let's take BugatTea to a $Billion token! Together, we race towards the moon! 🚀
          </p>
          <div className="contract-container">
            <span className="contract-label">$BUGATTEA CA:</span>
            <div className="contract-address" id="contract-address">0x123...ABC</div>
            <button
              className="copy-button"
              id="copy-button"
              onClick={() => {
                const contractText = document.getElementById('contract-address')?.innerText;
                if (contractText) {
                  navigator.clipboard.writeText(contractText)
                    .then(() => {
                      const copyBtn = document.getElementById('copy-button');
                      copyBtn.innerText = 'Copied!';
                      copyBtn.style.backgroundColor = '#4CAF50'; // Change button color to green
                      setTimeout(() => {
                        copyBtn.innerText = 'Copy';
                        copyBtn.style.backgroundColor = '#f59e0b'; // Reset button color
                      }, 2000);
                    })
                    .catch((err) => {
                      console.error('Failed to copy: ', err);
                    });
                }
              }}
            >
              Copy
            </button>
          </div>
        </div>
      </section>

      {/* Information Section */}
      <section className="info-section">
        <div className="info-grid">
          <div>
            <h4 className="info-title">BugatTea Token</h4>
            <p className="info-description">A community-driven and fully decentralized token inspired by luxury and speed.</p>
          </div>
          <div>
            <h4 className="info-title">Contract Address</h4>
            <p className="info-description">0x123...ABC</p>
          </div>
          <div>
            <h4 className="info-title">Contact</h4>
            <p className="info-description">Join one of our communities</p>
          </div>
        </div>
        <div className="disclaimer-container">
          <h3 className="disclaimer-title">Disclaimer</h3>
          <p className="disclaimer-text">
            BugatTea ($BUGATTEA) is a community-driven memecoin with no central ownership or authority. This website is for informational and entertainment purposes only and does not offer financial advice. Crypto investments carry risks, and users are responsible for compliance with local laws and regulations. Participation in BugatTea is at your own risk.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; 2025 BugatTea. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;